export const protocolo = [
    {
        "titulo" : "CEPCI",
        "descripcion" : "Comité de Ética y Prevención de Conflictos de Interes",
        "trimestres" : [
            {
                 "trimestre" : "Integrantes",
                 "url" : "../../Cepci/_CEPCI_Organigrama2025.pdf"
             },
            // {
            //     "trimestre" : "Cuarto Trimestre",
            //     "url" : "../../Transparencia/historico/2022/UPLAPH_4toTrim2022.zip"
            // }
            {
                "trimestre" : "Codigo de Conducta de la Unidad de Planeación y Prospectiva",
                "url" : "../../Cepci/CodigoConducta_UPLAPH.pdf"
            },
            {
                "trimestre" : "Código de Ética de la Administración pública del Estado de Hidalgo",
                "url" : "../../Cepci/Codigo_Etica_Hidalgo.pdf"
            },

        ]
    },
    {
        "titulo" : "Protocolo CERO",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Personas Consejeras",
                "url" : "../../Protocolo/IntegrantesPROTOCOLOCERO2025.pdf"
            },
            {
                "trimestre" : "Pronunciamiento de Cero Tolerancia",
                "url" : ".../../Protocolo/Pronunciamiento_CeroTolerancia2025.pdf"
            },
            {
                "trimestre" : "Proceso de Denuncia",
                "url" : ".../../Protocolo/Protocolo_Denuncias.pdf"
            }
        ]
    
    }
]